<h1 mat-dialog-title class="active">
    {{ "app.dialog.generate-planning." + data + ".title.label" | translate }}
</h1>

<div class="info-text">
    <mat-icon>info</mat-icon>
    <p>{{ "app.dialog.generate-planning." + data + ".info.label" | translate }}
    </p>
</div>

<mat-divider></mat-divider>


<div mat-dialog-content class="container" [formGroup]="formGroup">

    <mat-form-field appearance="fill">
        <mat-label>{{ "app.dialog.generate-planning.sourceDaterange.label" | translate }}</mat-label>
        <mat-date-range-input [formGroup]="formGroup.controls.sourceDaterange" [rangePicker]="sourcePicker">
            <input matStartDate formControlName="from">
            <input matEndDate formControlName="to">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="sourcePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #sourcePicker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>{{ "app.dialog.generate-planning.targetDaterange.label" | translate }}</mat-label>
        <mat-date-range-input [formGroup]="formGroup.controls.targetDaterange" [rangePicker]="targetPicker">
            <input matStartDate formControlName="from">
            <input matEndDate formControlName="to">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="targetPicker"></mat-datepicker-toggle>
        <mat-date-range-picker #targetPicker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field *ngIf="data === planningGenerationType.PURCHASE_PRICE" appearance="fill">
        <mat-label>{{ "app.dialog.generate-planning.sourcePrices.label" | translate }}</mat-label>
        <mat-select [formControl]="formGroup.controls.sourcePrices">
            <mat-option *ngFor="let option of sourcePriceOption | keyvalue" [value]="option.key">
                {{ "app.dialog.generate-planning.sourcePrices-" + option.key + ".label" | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data === planningGenerationType.PURCHASE_PRICE" appearance="fill">
        <mat-label>{{ "app.dialog.generate-planning.aggregation.label"  | translate }}</mat-label>
        <mat-select [formControl]="formGroup.controls.aggregationOption">
            <mat-option *ngFor="let option of aggregationOption | keyvalue" [value]="option.key">
                {{ "app.dialog.generate-planning.aggregation-" + option.key + ".label" | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>{{ "app.dialog.generate-planning.override.label" | translate }}</mat-label>
        <mat-select [formControl]="formGroup.controls.overrideOption">
            <mat-option *ngFor="let option of overrideOption | keyvalue" [value]="option.key">
                {{ "app.dialog.generate-planning.override-" + option.key + ".label" | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>

<div mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close (click)="close()">{{ "app.button.cancel.label" | translate }}</button>
    <button
        [disabled]="!formGroup.valid"
        mat-flat-button
        color="primary"
        (click)="save()">{{ "app.button.save.label" | translate }}
    </button>
</div>
